// Image that eases in (zooms) on hover while its frame stays put: the
// wrapper keeps the size, rounded corners and clipping, and only the image
// inside scales. Skipped for visitors who prefer reduced motion.
//
// Props
//   src        image source
//   alt        alt text (decorative by default)
//   className  wrapper classes — size and rounded corners go here
//   scale      hover scale as a Tailwind class (default 'group-hover:scale-110')
export default function HoverZoomImage({ src, alt = '', className = '', scale = 'group-hover:scale-110' }) {
  return (
    <div className={`group relative isolate overflow-hidden ${className}`}>
      <img
        src={src}
        alt={alt}
        className={`absolute inset-0 h-full w-full object-cover motion-safe:transition-transform motion-safe:duration-700 motion-safe:ease-out ${scale}`}
      />
    </div>
  );
}
